import axios from "axios";
import { AppDispatch } from "../store";
import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import {
  setCarBrand,
  setCarBrandList,
  setIsWaitingCarBrandGetResponse,
  setIsWaitingCarBrandPostResponse,
  setIsWaitingCarBrandPutResponse,
} from "../slices/carBrandSlice";
import { getApiUrl } from "../helpers/environmentHelper";
import { CarBrand } from "../../models/responses/carBrand";
import { acquireApiToken } from "../helpers/apiTokenHelper";

export const getCarBrands =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null
  ) =>
    async (dispatch: AppDispatch) => {
      const baseUrl = getApiUrl(window.location.hostname, 2);
      dispatch(setIsWaitingCarBrandGetResponse(true));
      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              if (response) {
                const getData: CarBrand[] = (
                  await axios.get(`${baseUrl}/carbrands`, {
                    timeout: 10000,
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${response.accessToken}`,
                    },
                  })
                ).data;
                dispatch(setCarBrandList({ carBrands: getData }));
                dispatch(setIsWaitingCarBrandGetResponse(false));
              }
            });
        }
      } catch (error) {
        dispatch(setIsWaitingCarBrandGetResponse(false));
        console.log(error);
      }
    };

export const getCarBrandById =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    id: string | undefined
  ) =>
    async (dispatch: AppDispatch) => {
      if (!id) return;
      const baseUrl = getApiUrl(window.location.hostname, 2);
      dispatch(setIsWaitingCarBrandGetResponse(true));

      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              if (response) {
                const getData: CarBrand = (
                  await axios.get(`${baseUrl}/carbrands/${id}`, {
                    timeout: 10000,
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${response.accessToken}`,
                    },
                  })
                ).data;
                dispatch(setCarBrand({ carBrand: getData }));
                dispatch(setIsWaitingCarBrandGetResponse(false));
              }
            });
        }
      } catch (error) {
        dispatch(setIsWaitingCarBrandGetResponse(false));
        console.log(error);
      }
    };

export const postCarBrand =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    carBrand: CarBrand,
    onSuccess: (carBrandId: string | null) => void
  ) =>
    async (dispatch: AppDispatch) => {
      dispatch(setIsWaitingCarBrandPostResponse(true));
      const baseUrl = getApiUrl(window.location.hostname, 2);
      let responseId: string | null = null;
      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              try {
                if (response) {
                  const responseData = await axios.post(
                    `${baseUrl}/carbrands`,
                    carBrand,
                    {
                      timeout: 10000,
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${response.accessToken}`,
                      },
                    }
                  );

                  if (responseData.status === 201) {
                    let locationArray =
                      responseData.headers["location"].split("/");
                    responseId = locationArray[locationArray.length - 1];
                  }
                }
              } finally {
                onSuccess(responseId);
                dispatch(setIsWaitingCarBrandPostResponse(false));
              }
            });
        }
      } catch (error) {
        console.log(error);
      }
    };

export const putCarBrand =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    carBrand: CarBrand,
    onSuccess: (carBrandId: string | null) => void
  ) =>
    async (dispatch: AppDispatch) => {
      const baseUrl = getApiUrl(window.location.hostname, 2);
      dispatch(setIsWaitingCarBrandPutResponse(true));
      try {
        if (account) {
          acquireApiToken(instance, account)
            .then(async (response) => {
              try {
                if (response) {
                  const responseData = await axios.put(
                    `${baseUrl}/carbrands`,
                    carBrand,
                    {
                      timeout: 10000,
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${response.accessToken}`,
                      },
                    }
                  );
                  if (responseData.status === 204) {
                    onSuccess(carBrand.id);
                  }
                }
              } finally {
                dispatch(setIsWaitingCarBrandPutResponse(false));
              }
            });
        }
      } catch (error) {
        console.log(error);
      }
    };
